__turbopack_context__.v({
  "className": "fontawesome_43938e2e-module__dAtCdq__className",
  "variable": "fontawesome_43938e2e-module__dAtCdq__variable",
});
